import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {select, Store} from '@ngrx/store';
import {LanguageService} from '../../../core/services/language.service';
import * as fromLayout from '../../../reducers';
import {I18nDictionaryComponent} from '../../../shared/components/i18n-dictionary/i18n-dictionary.component';
import {TitleService} from '../../../shared/services/title.service';
import * as AuthActions from '../../actions/user.actions';
import * as fromReset from '../../reducers';
import '../../../shared/components/navigable';
import {ActivatedRoute} from '@angular/router';
import {AuthError, AuthErrorCodes} from '../../models/auth-error';

@Component({
    selector: 'app-password-reset-page',
    templateUrl: './password-reset-page.component.html',
    styleUrls: ['./password-reset-page.component.scss']
})
export class PasswordResetPageComponent implements OnInit, AfterViewInit, Navigable {
    static readonly COMPONENT_ID = 'PasswordResetPageComponent';

    readonly titleTextId = 'login-page_title';

    isPending$;
    resetError$;
    resetSuccessful$;
    isSiteMenuOpen$;
    params;

    @ViewChild(I18nDictionaryComponent, {static: true})
    i18nDictionary: I18nDictionaryComponent;

    constructor(private store: Store<fromReset.State>, private titleService: TitleService,
                private languageService: LanguageService, private route: ActivatedRoute) {
    }

    ngOnInit(): void {
        this.resetSuccessful$ = this.store.pipe(select(fromReset.getPasswordResetSuccessful));
        this.isPending$ = this.store.pipe(select(fromReset.getResetIsPending));
        this.resetError$ = this.store.pipe(select(fromReset.getPasswordResetError));
        this.isSiteMenuOpen$ = this.store.pipe(select(fromLayout.getIsSiteMenuOpen));

        this.route.queryParams.subscribe(params => this.params = params);
    }

    ngAfterViewInit(): void {
        this.titleService.setTitle(this.i18nDictionary.get(this.titleTextId));
    }

    onReset(userForm: { password: string }) {
        console.log(this.params);
        if (!this.params.token || !this.params.customer) {
            const authError = new AuthError(AuthErrorCodes.InvalidCredentials, 'Wrong reset token, please request another email');

            this.store.dispatch(AuthActions.resetFailure({authError}));
            return;
        }

        this.store.dispatch(AuthActions.reset({
            resetToken: this.params.token,
            newPassword: userForm.password,
            email: this.params.customer
        }));
    }

    getId(): string {
        return PasswordResetPageComponent.COMPONENT_ID;
    }

}
